export default "__VITE_ASSET__CYeEkssj__"